import CampaignCard from './CampaignCard';
import CampaignGrid from './CampaignGrid';
import CampaignRowCard from './CampaignRowCard';
import CampaignCarousel from './CampaignCarousel';
import HeroBanner from './HeroBanner';
import SectionHeader from './SectionHeader';
import styles from './HomeSections.module.css';

// 히어로 옆 열의 높이가 히어로와 맞아떨어지는 수.
const SPOTLIGHT_ROWS = 3;
const GRID_LIMIT = 8;

/** 히어로 1건 + 가로형 카드 목록. 홈 첫 섹션에 위계를 만든다. */
function Spotlight({ section }) {
  const [lead, ...rest] = section.items;
  const rows = rest.slice(0, SPOTLIGHT_ROWS);

  return (
    <section className={styles.section}>
      <SectionHeader title={section.title} />
      <div className={`${styles.spotlight}${rows.length === 0 ? ` ${styles.spotlightSolo}` : ''}`}>
        <HeroBanner campaign={lead} />
        {rows.length > 0 && (
          <div className={styles.spotlightSide}>
            {rows.map((item) => (
              <CampaignRowCard key={item.id} campaign={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

function CampaignSection({ section, onBookmark, isScrapped }) {
  const cards = (section.layoutType === 'GRID' ? section.items.slice(0, GRID_LIMIT) : section.items).map((item) => (
    <CampaignCard
      key={item.id}
      campaign={item}
      onBookmark={onBookmark}
      isScrapped={isScrapped(item.id)}
    />
  ));

  return (
    <section className={styles.section}>
      <SectionHeader title={section.title} />
      {section.layoutType === 'HORIZONTAL'
        ? <CampaignCarousel>{cards}</CampaignCarousel>
        : <CampaignGrid>{cards}</CampaignGrid>}
    </section>
  );
}

/** 섹션이 도착하기 전 자리를 잡아둔다 (레이아웃 점프 방지). */
export function HomeSectionsSkeleton() {
  return (
    <section className={styles.section} aria-hidden="true">
      <div className={`${styles.skelTitle} ${styles.skel}`} />
      <div className={styles.spotlight}>
        <div className={`${styles.skelHero} ${styles.skel}`} />
        <div className={styles.spotlightSide}>
          {Array.from({ length: SPOTLIGHT_ROWS }, (_, i) => (
            <div className={styles.skelRow} key={i}>
              <div className={`${styles.skelThumb} ${styles.skel}`} />
              <div className={styles.skelLines}>
                <div className={`${styles.skelLine} ${styles.skelLineShort} ${styles.skel}`} />
                <div className={`${styles.skelLine} ${styles.skel}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function HomeSections({ sections, onBookmark, isScrapped }) {
  let spotlightUsed = false;

  return sections.map((section, index) => {
    // 서버가 내려주는 BANNER 섹션은 웹에서 노출하지 않는다 (앱 전용).
    if (section.sectionType !== 'CAMPAIGN' || !section.items?.length) return null;

    // 첫 체험단 섹션만 히어로형으로 크게 보여준다.
    if (!spotlightUsed) {
      spotlightUsed = true;
      return <Spotlight key={section.title ?? index} section={section} />;
    }
    return (
      <CampaignSection
        key={section.title ?? index}
        section={section}
        onBookmark={onBookmark}
        isScrapped={isScrapped}
      />
    );
  });
}
